module.exports = __webpack_public_path__ + "img/diversidadofertas.bc65cddb.png";